export default __webpack_public_path__ + "navigation-camera-geometry-framing-after-maneuver-disabled-960-037c3d34f20e19cdefaa5c326c72276b.webp";